export const GO_FLOATING_CHAT_TRIGGERS_READY = Symbol.for('go_floating_chat_triggers_ready');

export const EVENTS = {
    GO_OPEN_FLOATING_CHAT: 'go_open_floating_chat',
} as const;

export const POLLING_DELAY = 250;
export const EMITTER_TIMEOUT = 5000;
export const POLLING_ATTEMPTS = Math.floor(EMITTER_TIMEOUT / POLLING_DELAY);

export interface EventProps<T> {
    data?: T;
}
